import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import '../../static/css/modal.less';
import {useUserQuotaStore} from '../../context/userQuotaStore';
import config from '../../service/config';
import {AlertModalPortal} from '../util/ModalPortalHelper';

export const UserOverQuotaModalBase: React.FC<IUserOverQuotaProps> = ({children}) => {
   const {t} = useTranslation();
   const {userHasQuotaInformation, videoCountExceeded} = useUserQuotaStore(s => ({userHasQuotaInformation: s.UserHasQuotaInformation, videoCountExceeded: s.VideoCountExceeded}));
   const [showQuotaAlert, setShowQuotaAlert] = React.useState(false);

   const userOverQuotaContainerClicked = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      e.stopPropagation();
      e.preventDefault();
      setShowQuotaAlert(true);
   };

   const openUpgradeLink = () => {
      window.open(config.environmentData.ScreencastProPurchaseLinkUrl, '_blank');
   };

   const isOverQuota = config.featureSwitches.EnableScreencastProEntitlement && userHasQuotaInformation && videoCountExceeded;

   return isOverQuota ?
      showQuotaAlert ?
         (
            <>
               {children}
               <AlertModalPortal
                  data-test-id="user-over-quota-modal"
                  title={t('userQuotas.overQuotaModal.title')}
                  onConfirm={() => setShowQuotaAlert(false)}
                  confirmContent={t('general.close')}
                  confirmButtonType={TscButtonType.primary}
                  onClose={() => setShowQuotaAlert(false)}
                  onDismiss={openUpgradeLink}
                  dismissContent={t('userQuotas.overQuotaModal.upgradeButton')}
                  dismissButtonType={TscButtonType.secondary}
               >
                  {t('userQuotas.overQuotaModal.body')}
               </AlertModalPortal>
            </>
         ) : (
            <div
               data-test-id="user-over-quota-click-container"
               onClick={userOverQuotaContainerClicked}
            >
               {children}
            </div>
         ) : (
         <>
            {children}
         </>
      );
};

export interface IUserOverQuotaProps {
   children?: React.ReactNode;
}

export default memo(UserOverQuotaModalBase);
